import { createMuiTheme } from "@material-ui/core/styles";

export const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    // primary: {
    //   main: "#65C988",
    // },
    // error: {
    //   main: "#c66065",
    // },
    textColor: "#FAFAFA",
    backgroundTheme: "#192039",
    background: {
      main: "#000",
      primary: "#121212",
      secondary: "#292929",
      secondary2: "#000",
      input: "#000",
      // dialog: '#0A0A0A',
      dialog: "#1A1A1A",
      disabled: "#2F2F2F",
      hover: "#000",
      overlay: "rgba(0,0,0,0.6)",
    },
    text: {
      primary: "#FAFAFA",
      secondary: "#C5C5C5",
      disabled: "#C5C5C5",
      placeholder: "#606060",
      title: "#fff",
    },
    border: {
      lightBorder: "#333",
    },
  },
  typography: {
    fontFamily: "Montserrat",
    // htmlFontSize: 10,
  },

  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
  },
});

export const lightTheme = createMuiTheme({
  palette: {
    type: "light",
    // primary: "#F630A9",

    // hover: "#354256",
    // menuBg: "#3D4C62",
    // background: "#F5F7FA",
    // green: "#1ED059",
    // background: #F630A9;

    // text: "#000000",
    primary: {
      main: "#FFFFFF",
    },
    secondary: {
      main: "#F630A9",
    },
    textColor: "#192039",
    backgroundTheme: "#f8f8f8",
    background: {
      main: "#F5F5F5",
      primary: "#fff",
      secondary: "#F5F5F5",
      input: "#F5F5F5",
      dialog: "#fff",
      secondary2: "#fff",
      disabled: "#E2E2E2",
      hover: "#354256",
      overlay: "rgba(0,0,0,0.6)",
    },
    text: {
      primary: "#192039",
      secondary: "#000000",
      disabled: "#C5C5C5",
      placeholder: "#606060",
      title: "#fff",
      main: "#1E304A",
    },
    border: {
      lightBorder: "#E7E8EA",
    },
  },
  typography: {
    fontFamily: "Montserrat",
    fontWeight: 900,
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
        background: "#F630A9",
        color: "#fff",
        hover: "#354256",
      },
    },
  },
});
